import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import urls from '../common/js/urls.js'

//模考列表
export function api_drypractice_list(context,user_id) {
  var promise = new Promise(function(resolve,reject){
      var domain = window.location.host;
      var application_id = 1;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
           application_id = 300;
      }

      axios.get(urls.dry_practice_list + '?new=1&paperTypeId=201607301639232601224301&userid='+user_id+"&application_id="+application_id).then((response) => {
        resolve(response.data.exams[0]);
      }).catch((response) => {
        reject(response);
      });
  });
 return promise;
};


//参加模考
export function api_submit_join(context,userid,paperId) {
  var promise = new Promise(function(resolve,reject){
     var domain = window.location.host;
      var application_id = 1;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
           application_id = 300;
      }
      axios.post(urls.dry_join + '?userid='+userid + '&paperId='+ paperId+"&application_id="+application_id).then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
  });
 return promise;
};


//获取模考服务器时间
export function api_server_time(context,userid,paperId) {
  var promise = new Promise(function(resolve,reject){
     var domain = window.location.host;
      var application_id = 1;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
           application_id = 300;
      }
      axios.get(urls.dry_server_time + '?user_id='+userid + '&paperId='+ paperId+"&application_id="+application_id).then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
  });
 return promise;
};


//模考试卷详情
export function api_content_getexam(context ,user_id, paperId) {
    var promise = new Promise(function(resolve,reject){
       var domain = window.location.host;
      var application_id = 1;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
           application_id = 300;
      }
        var base_url = urls.dry_all_detail +  '?userid='+user_id+"&paperId="+paperId+"&paperTypeId=201607301639232601224301"+"&application_id="+application_id;
        axios.get(base_url).then((response) => {
            var result = response.data.result;
            resolve(result);

        }).catch((response) => {
            reject(response);
        })
    });

    return promise;
};

//模考交卷
export function api_content_subpostexam(context ,postdata,userid,paperId) {
    var promise = new Promise(function(resolve,reject){
       var domain = window.location.host;
      var application_id = 1;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
           application_id = 300;
      }
        var base_url = urls.dry_submit;
        var params = [
            "application_id"+application_id,
            "userid="+userid,
            "paperId="+paperId,
            "paperResult="+postdata,
            "paperType=1",
            "submitType=1"
        ]
        var str_params = params.join("&");

        axios.post(base_url,str_params).then((response) => {
            //var result = response.data.result;
            resolve(response);

        }).catch((error) => {
            reject(error);
        })
    });

    return promise;
};



//模考报告
export function api_dry_result(context,userid,paperId) {
  var promise = new Promise(function(resolve,reject){
     var domain = window.location.host;
      var application_id = 1;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
           application_id = 300;
      }

      axios.post(urls.dry_result + '?userid='+userid + '&paperId='+ paperId+"&application_id="+application_id).then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
  });
 return promise;
};

//获取单个题目解析
export function api_analysis_info(context,userid,subjectId) {
  var promise = new Promise(function(resolve,reject){
     var domain = window.location.host;
      var application_id = 1;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
           application_id = 300;
      }

      axios.post(urls.dry_analysis + '?userid='+userid + '&subjectId='+ subjectId+"&application_id="+application_id).then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
  });
 return promise;
};




// WEBPACK FOOTER //
// ./src/networks/DryRun.js